import script from "./JewelDimensionInputs.vue?vue&type=script&setup=true&lang=ts"
export * from "./JewelDimensionInputs.vue?vue&type=script&setup=true&lang=ts"

import "./JewelDimensionInputs.vue?vue&type=style&index=0&id=13edfad5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13edfad5"]])

export default __exports__